const MS_PER_SECOND = 1000

const SECONDS_PER_MINUTE = 60
const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * 60
const SECONDS_PER_DAY = SECONDS_PER_HOUR * 24

export const isTimeInTheFuture = (timeInSeconds: number) => {
  const currentTimeInSeconds = Math.floor(new Date().getTime() / MS_PER_SECOND)

  return currentTimeInSeconds < timeInSeconds
}

export const isDateInTheFuture = (date: string | undefined | null) => {
  if (!date) return undefined

  const dateInSeconds = Math.floor(Date.parse(date) / MS_PER_SECOND)

  if (Number.isNaN(dateInSeconds)) return undefined

  return isTimeInTheFuture(dateInSeconds)
}

export const calculateRemainingTime = (futureTimeInSeconds: number) => {
  const currentTimeInSeconds = Math.floor(new Date().getTime() / MS_PER_SECOND)

  return futureTimeInSeconds - currentTimeInSeconds
}

export const formatTime = (timeInSeconds: number) => {
  const days = Math.floor(timeInSeconds / SECONDS_PER_DAY)
  const hours = Math.floor((timeInSeconds % SECONDS_PER_DAY) / SECONDS_PER_HOUR)
  const minutes = Math.floor((timeInSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE)
  const seconds = Math.floor(timeInSeconds % SECONDS_PER_MINUTE)

  return { seconds, minutes, hours, days }
}
